import create from 'zustand';

import { retrieveFromSessionStorage, saveToSessionStorage } from '../../utils/web-storage';
import type { GptHelpInfo } from './types';

export interface CodingState {
    // номер теста
    selectedTest: number;
    setSelectedTest: (selected: number) => void;

    code: string;
    setCode: (code: string) => void;

    help: Record<number, GptHelpInfo | null | undefined>;
    setHelp: (problemId: number, help: GptHelpInfo | null) => void;

    lastSubmit: Record<number, 'run-code' | 'submit-answer' | undefined>;
    setLastSubmit: (problemId: number, lastSubmit: 'run-code' | 'submit-answer') => void;

    submitCount: number;
    incrementSubmitCount: () => void;

    // табы на мобиле
    activeTab: 'task' | 'code' | 'tests';
    setActiveTab: (activeTab: CodingState['activeTab']) => void;

    // Сфокусировались на вводе на мобиле
    isFocusOnInput: boolean;
    setIsFocusOnInput: (isFocusOnInput: boolean) => void;

    gptPopupVisible: boolean;
    setGptPopupVisible: (visible: boolean) => void;

    customTestInput: string;
    setCustomTestInput: (customTestInput: string) => void;
}

const gptPopupSessionKey = 'coding-gpt-popup-closed';

export const useCodingStore = create<CodingState>((set, get) => ({
    selectedTest: 0,
    setSelectedTest: (selectedTest) => set({ selectedTest }),

    code: '',
    setCode: (code) => set({ code }),

    help: {},
    setHelp: (problemId, result) =>
        set(({ help }) => ({
            help: { ...help, [problemId]: result },
        })),

    lastSubmit: {},
    setLastSubmit: (problemId, lastSubmit) =>
        set((s) => ({
            lastSubmit: { ...s.lastSubmit, [problemId]: lastSubmit },
        })),

    submitCount: 0,
    incrementSubmitCount: () => set({ submitCount: get().submitCount + 1 }),

    activeTab: 'task',
    setActiveTab: (activeTab) => set({ activeTab }),

    isFocusOnInput: false,
    setIsFocusOnInput: (isFocusOnInput) => set({ isFocusOnInput }),

    gptPopupVisible: !retrieveFromSessionStorage(gptPopupSessionKey),
    setGptPopupVisible: (gptPopupVisible) => {
        set({ gptPopupVisible });
        saveToSessionStorage(gptPopupSessionKey, 'true');
    },

    customTestInput: '',
    setCustomTestInput: (customTestInput) => set({ customTestInput }),
}));
